import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { openDialog } from '../../base/dialog';
import { denyRequest } from '../../visitors/actions';
import { ACTION_TRIGGER, MEDIA_STATE } from '../constants';
import { ParticipantItem } from './ParticipantItem';
import VisitorPromotionDialog from './VisitorPromotionDialog';
const spacerStyle = { width: '10px' };
export const VisitorsItem = ({ request: r }) => {
    const { from, nick } = r;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const reject = useCallback(() => dispatch(denyRequest(r)), [dispatch, r]);
    const openPromotionDialog = useCallback(() => dispatch(openDialog(VisitorPromotionDialog, { request: r })), [dispatch, r]);
    // Laid out exactly like a lobby knock (LobbyParticipantItem): the row is the
    // same width and the pane's own action buttons keep the name from being
    // squeezed, which the generic ui Button did.
    return (React.createElement(ParticipantItem, { actionsTrigger: ACTION_TRIGGER.PERMANENT, audioMediaState: MEDIA_STATE.NONE, hideOptions: true, isModerator: false, name: nick, participant: { id: from }, videoMuteState: MEDIA_STATE.NONE },
        React.createElement("button", { "aria-label": `${t('participantsPane.actions.admit')} ${nick}`, className: 'participant-action-button-primary', "data-testid": `admit-${from}`, onClick: openPromotionDialog, type: 'button' }, t('participantsPane.actions.admit')),
        React.createElement("div", { style: spacerStyle }),
        React.createElement("button", { "aria-label": `${t('participantsPane.actions.reject')} ${nick}`, className: 'participant-action-button-secondary', "data-testid": `reject-${from}`, onClick: reject, type: 'button' }, t('participantsPane.actions.reject'))));
};
